import React, { useEffect, useState } from 'react';

import {
  Button,
  Card, Col, Form, Row, Select,
} from 'antd';

import {
  FormItemSelect,
  FormItemInput,
} from '../../../components/ant-wrapper/form-item';
import { getCidades } from '../../../services/districts';
import { gerarRelatorioUnidades } from '../../../services/relatorios';

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 18 },
};
const cardStyle = { borderColor: 'white' };
export default function RelatorioUnidades() {
  const [form] = Form.useForm();
  const [cidades, setCidades] = useState([]);

  const onSubmit = async (values) => {
    await gerarRelatorioUnidades(values);
  };
  const getData = async () => {
    const cidadesData = await getCidades();
    setCidades(cidadesData);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div style={{ width: '100%' }}>
      <Form
        form={form}
        name="register"
        onFinish={onSubmit}
        scrollToFirstError
        {...formItemLayout}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <FormItemInput name="nome" label="Nome" />

          </Col>

          <Col span={8}>
            <FormItemSelect
              name="cidade"
              label="Cidade"
              items={cidades}
              itemsLabel="cidade"
              itemsValue="cidade"
            />
          </Col>

        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Enviar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
